import { EVENT_DRAFT_MAX_IMAGES } from '@pulsify/shared/dto'

const PICTURE_NAME = /\.(jpe?g|png|webp|heic|heif)$/i

function isPicture(file: File): boolean {
  return file.type.startsWith('image/') || (!file.type && PICTURE_NAME.test(file.name))
}

/** The pictures after adding new ones: only pictures, at most three, in the order added. */
export function addPictures(
  current: File[],
  incoming: File[],
): { pictures: File[]; skipped: number } {
  const fitting = incoming.filter(isPicture)
  const room = Math.max(0, EVENT_DRAFT_MAX_IMAGES - current.length)
  const added = fitting.slice(0, room)
  return {
    pictures: [...current, ...added],
    skipped: incoming.length - added.length,
  }
}
